/* eslint-disable wrap-iife */
/* eslint-disable space-before-function-paren */
// 浏览器相关方法
const BrowserFun = {
  versions: (function() {
    const ua = navigator.userAgent;
    return {
      trident: ua.indexOf('Trident') > -1, // IE浏览器
      presto: ua.indexOf('Presto') > -1, // opera浏览器
      webKit: ua.indexOf('AppleWebKit') > -1, // 谷歌/苹果浏览器
      gecko: ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') === -1, // 火狐浏览器
      mobile: !!ua.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1, // android终端或uc浏览器
      iPhone: ua.indexOf('iPhone') > -1, // iPhone/QQHD浏览器
      iPad: ua.indexOf('iPad') > -1, // iPad端
      webApp: ua.indexOf('Safari') === -1, // web应用程序，没有头部与底部
      qq: ua.toLowerCase().indexOf('qq') > -1, // 是否在QQ内或QQ浏览器打开
      weixin: ua.toLowerCase().indexOf('micromessenger') > -1, // 微信内打开
      weibo: ua.toLowerCase().indexOf('weibo') > -1, // 微博内打开
    };
  })(),
};

export default {
  // 修改APP标题
  setAppTitle(title) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.setPageTitle(title)
       * @param title   页面标题
       */
      window.phone_share_js_interface.setPageTitle(title);
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * 分享按钮是否显示
       * document.location = 'ios_h5_share::title::content::url'
       * @param title   标题
       */
      document.location = 'ios_setpagetitle::' + title;
    }
  },
  // 跳转到词书下载页
  selectVocabulary(vocabularyId) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.selectVocabulary(int vocabularyId)
       * @param vocabularyId   词库ID
       */
      window.phone_share_js_interface.selectVocabulary(vocabularyId);
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'ios_selectVocabulary::vocabularyId'
       * @param vocabularyId   词库ID
       */
      document.location = 'ios_selectVocabulary::' + vocabularyId;
    }
  },
  // 跳转到课程视频页面
  selectMultiVideoPage(activityId, type, tagType, customParam = '') {
    // [type 类型]              2-课程 13-活动（词汇营、全程班等）18-服务号商品 22-词库
    // [type= 2时,tagType的取值] 1-讲词课程  2-专题课程  3-学习专栏 4-BBC地道英语 5-BBC英语大破解 6-在线引流课 7-代销课程
    // [type=13时,tagType的取值] 0-词汇营 1-全程班 2-冲刺班 3-训练营专项子类型 4-全程班专项子类型 5-课程
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.selectMultiVideoPage(int activityId, int type, int tagType, string customParam)
       * @param activityId    活动/课程ID
       * @param type 类型
       * @param tagType  细分类型
       * @param customParam 渠道码
       */
      try {
        window.phone_share_js_interface.selectMultiVideoPage(
          activityId,
          type,
          tagType,
          customParam
        );
      } catch (error) {
        window.phone_share_js_interface.selectMultiVideoPage(
          activityId,
          type,
          tagType
        );
      }
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'ios_selectMultiVideoPage::activityId::type::tagType::customParam'
       * @param activityId    活动/课程ID
       * @param type 类型
       * @param tagType  细分类型
       * @param customParam 渠道码
       */
      document.location =
        'ios_selectMultiVideoPage::' +
        activityId +
        '::' +
        type +
        '::' +
        tagType +
        '::' +
        customParam;
    }
  },
  // 是否开启了相机权限
  isOpenCameraPermission() {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.isOpenCameraPermission()
       */
      window.phone_share_js_interface.isOpenCameraPermission();
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'isOpenCameraPermission'
       */
      document.location = 'isOpenCameraPermission';
    }
  },
  // 保存证书
  saveNaevPirze(group, level, studentName) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.saveCertificate(int group, int level, String studentName)
       * @param group   group ：组别 1-高职高专 2-本科 3-研究生 ( level=5时：1-优秀、2-杰出、3-卓越)
       * @param level   level : 0-优胜奖、1-一等奖、2-二等奖、3-三等奖、4-特等奖（组别0）、5-志愿者
       * @param studentName 学生姓名
       */
      window.phone_share_js_interface.saveCertificate(
        group,
        level,
        studentName
      );
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'saveCertificate::group::level::studentName'
       * @param group   group ：组别 1-高职高专 2-本科 3-研究生 ( level=5时：1-优秀、2-杰出、3-卓越)
       * @param level   level : 0-优胜奖、1-一等奖、2-二等奖、3-三等奖、4-特等奖（组别0）、5-志愿者
       * @param studentName 学生姓名
       */
      document.location =
        'saveCertificate::' + group + '::' + level + '::' + studentName;
    }
  },
  // 跳转到提现中心
  cashRedpack(channel) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.cashRedpack(string channel)
       * @param channel   活动ID
       */
      window.phone_share_js_interface.cashRedpack(channel.toString());
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'cashRedpack::channel'
       */
      document.location = 'cashRedpack::' + channel.toString();
    }
  },
  // 词书购买页面「不能传免费词书ID」
  gotoVocabularyPayPage(vocabularyId, customParam = '') {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoVocabularyPayPage(int vocabularyId, string customParam)
       * @param vocabularyId 词书ID
       * @param customParam  渠道码
       */
      try {
        window.phone_share_js_interface.gotoVocabularyPayPage(
          vocabularyId,
          customParam
        );
      } catch (error) {
        window.phone_share_js_interface.gotoVocabularyPayPage(vocabularyId);
      }
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoVocabularyPayPage::vocabularyId'
       * @param vocabularyId 词书ID
       * @param customParam  渠道码
       */
      document.location =
        'gotoVocabularyPayPage::' + vocabularyId + '::' + customParam;
    }
  },
  // App我的tab-问题反馈
  gotoFeedbackPage() {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoFeedbackPage()
       */
      window.phone_share_js_interface.gotoFeedbackPage();
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoFeedbackPage'
       */
      document.location = 'gotoFeedbackPage';
    }
  },
  // App我的tab-我的词书
  gotoMyDeckPage() {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoMyDeckPage()
       */
      window.phone_share_js_interface.gotoMyDeckPage();
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoMyDeckPage'
       */
      document.location = 'gotoMyDeckPage';
    }
  },
  // App我的tab-我的课程
  gotoMyCoursePage() {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoMyCoursePage()
       */
      window.phone_share_js_interface.gotoMyCoursePage();
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoMyCoursePage'
       */
      document.location = 'gotoMyCoursePage';
    }
  },
  // App我的tab-我的小组
  gotoMyTeamPage() {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoMyTeamPage()
       */
      window.phone_share_js_interface.gotoMyTeamPage();
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoMyTeamPage'
       */
      document.location = 'gotoMyTeamPage';
    }
  },
  // App词书标签
  gotoVocabularyTagPage() {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoVocabularyTagPage()
       */
      window.phone_share_js_interface.gotoVocabularyTagPage();
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoVocabularyTagPage'
       */
      document.location = 'gotoVocabularyTagPage';
    }
  },
  // 外部H5唤起课程、活动、服务号
  h5LinkToApp(id, type, tagType) {
    const category = 1;
    const url = `leci://com.xdf.recite?category=${category}&id=${id}&type=${type}&tagType=${tagType}`;
    window.location.href = url;
  },
  // 外部H5唤起词书
  h5LinkToAppVocabulary(vocabularyId) {
    const category = 2;
    const url = `leci://com.xdf.recite?category=${category}&vocabularyId=${vocabularyId}`;
    window.location.href = url;
  },
  // 跳转到指定小组
  gotoTeamInfoPage(groupId) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoTeamInfoPage()
       */
      window.phone_share_js_interface.gotoTeamInfoPage(groupId);
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoTeamInfoPage::groupId'
       */
      document.location = 'gotoTeamInfoPage::' + groupId;
    }
  },
  // 是否显示退出前确认弹框
  showBackConfirmDialog(message) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.isShowBackConfirmDialog(boolean isShow,String message)
       * @param isShow  是否显示弹框
       * @param message 弹框文案
       */
      try {
        window.phone_share_js_interface.isShowBackConfirmDialog(true, message);
      } catch (error) {
        console.log(error);
      }
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'isShowBackConfirmDialog::isShow::message'
       * @param isShow  是否显示弹框
       * @param message 弹框文案
       */
      try {
        document.location = 'isShowBackConfirmDialog::true::' + message;
      } catch (error) {
        console.log(error);
      }
    }
  },
  // 是否显示顶部刷新按钮
  showTopRefresh(message) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.isShowTopRefresh(boolean isShow,String url,String message)
       * @param isShow  是否显示弹框
       * @param url     当前页面url
       * @param message 弹框文案
       */
      try {
        window.phone_share_js_interface.isShowTopRefresh(
          true,
          window.location.href,
          message
        );
      } catch (error) {
        console.log(error);
      }
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'isShowTopRefresh::isShow::url::message'
       * @param isShow  是否显示顶部刷新按钮
       * @param url     当前页面url
       * @param message 弹框文案
       */
      try {
        document.location =
          'isShowTopRefresh::true::' + window.location.href + '::' + message;
      } catch (error) {
        console.log(error);
      }
    }
  },
  // 通用图片下载
  saveImg(type, info) {
    if (typeof info == 'object') {
      // eslint-disable-next-line
      info = JSON.stringify(info);
    }
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.saveCommonCertificate(String type,String info)
       * @param type  活动类型
       * @param info  扩展字段
       */
      window.phone_share_js_interface.saveCommonCertificate(type, info);
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'saveCommonCertificate::type::info'
       * @param type  活动类型
       * @param info  扩展字段
       */
      document.location = 'saveCommonCertificate::' + type + '::' + info;
    }
  },
  // 跳转到App我的tab-物流信息页面
  gotoLogisticsInfoPage() {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoLogisticsInfoPage()
       */
      window.phone_share_js_interface.gotoLogisticsInfoPage();
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoLogisticsInfoPage'
       */
      document.location = `gotoLogisticsInfoPage`;
    }
  },
  // webview跳转到微信小程序
  gotoMiniProgramPage(userName, path) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.gotoMiniProgramPage(String userName,String path)
       * @param userName  小程序Appid
       * @param path      路径
       */
      window.phone_share_js_interface.gotoMiniProgramPage(userName, path);
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'gotoMiniProgramPage::userName::info'
       * @param userName  小程序Appid
       * @param path      路径
       */
      document.location = `gotoMiniProgramPage::${userName}::${path}`;
    }
  },
  // 第八届学术英语竞赛证书保存
  saveNaev8Pirze(group, level, studentName, studentNumber) {
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       * window.phone_share_js_interface.saveCertificate(int group, int level, String studentName, String studentNumber)
       * @param group   group ：组别 1-高职高专 2-本科 3-研究生
       * @param level   level : 0-优胜奖、1-一等奖、2-二等奖、3-三等奖、4-特等奖（组别0）
       * @param studentName 学生姓名
       * @param studentNumber 证书编号
       */
      window.phone_share_js_interface.saveEighthCertificate(
        group,
        level,
        studentName,
        studentNumber
      );
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
       * document.location = 'saveCertificate::group::level::studentName::studentNumber'
       * @param group   group ：组别 1-高职高专 2-本科 3-研究生
       * @param level   level : 0-优胜奖、1-一等奖、2-二等奖、3-三等奖、4-特等奖（组别0）
       * @param studentName 学生姓名
       * @param studentNumber 证书编号
       */
      document.location = `saveEighthCertificate::${group}::${level}::${studentName}::${studentNumber}`;
    }
  },
};
